<template>
    <!-- <v-alert color="red" class="alert" transition="scroll-y-transition" v-show="expand" type="error">Sorry, we couldn't find a legislative district at that location.</v-alert> -->
    <v-alert color="red" class="alert" transition="scroll-y-transition" v-show="expand" type="error">Sorry, there is no district at that location.</v-alert>
</template>
<script>
import { EventBus } from "../../data/EventBus";

export default {
  name: "Alert",
  components: {},
  data: function () {
    return {
        expand: false,
        alertDisplayTime: 3000
    };
  },
  mounted: function () {
      EventBus.$on('alert',this.showAlert);
  },
  methods: {
      showAlert(){
          this.expand = true;
          
          setTimeout(()=>this.expand=false,this.alertDisplayTime)
      }
  },
  watch: {},
  computed: {},
};
</script>
<style scoped>
.alert{
    z-index: 1;
        /* width: 50%; */
    margin: 0 auto;
    display: table;
}
</style>